import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';		// map, tap, catchError, first

import { FireUserService } from "../../../modulo-comunes/servicios/fire-user-servicios";
import { FireEmpresaService } from "../../../modulo-comunes/servicios/fire-empresa-servicios";
import { DataUserService } from "../../../modulo-comunes/servicios/data-user-servicios";
import { FuncionesService } from "../../../modulo-comunes/servicios/funciones-servicios";
import { FechaHoraService } from "../../../modulo-comunes/servicios/fechahora-servicios";
import { MuestraService } from "../../../modulo-comunes/servicios/muestra-servicios";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { DataEmpresaService } from "../../../modulo-comunes/servicios/data-empresa-servicios";
import { PedirAccesoEmp } from '../../../modulo-comunes/interfaces/empresa-interfaces';
import { UserAut } from '../../../modulo-comunes/interfaces/user-interfaces';
import { userVacio, userAutVacio } from '../../../modulo-comunes/datos/user-data';

@Component({
  selector: 'app-pedir-acc-emp',
  templateUrl: './pedir-acc-emp.component.html',
  styleUrls: ['./pedir-acc-emp.component.css']
})
export class PedirAccesoEmpComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();
  formPedirAccesoEmp = this.fb.group({
    fTxtNombre: ["", [Validators.required, Validators.minLength(5)]],
    fTxtRUC: ["", [Validators.required, Validators.minLength(5)]],
    fChkAcepto: ["", [Validators.requiredTrue]]
  });

  userAutActual: UserAut;
  modeloEmpAnt = {}; //para evitar que presionen Crear varias veces y se intente la misma creación
  modeloEmpNue = {};
  //En este programa voy a usar la técnica del form, no la del modelo. 
  //pero voy a usar modeloRegistro para guardar los datos como variables. 
  modeloRegistro: PedirAccesoEmp = {
    autorizado: '',
    nombre: '',
    ruc: '',
    fechaHora: '',
    paeid: '',
    tipoUsuarioSolicitado: 'Usuario',
    userAutSolicNombre: '',
    userAutSolicMail: '',
    nombreReal: '',
    uid: ''
  };
  mensajeRegistro: string = '';
  mensajeRegistro2: string = '';

  okAcepto = false;
  formOk = false;
  formError = false;
  formDuplic = false;
  srcLogo: string;
  empresaPedir: PedirAccesoEmp;
  sitio: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private fireUserService: FireUserService,
    private fireEmpresaService: FireEmpresaService,
    private dataUserService: DataUserService,
    private funcionesService: FuncionesService,
    private fechaHoraService: FechaHoraService,
    private muestraService: MuestraService,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) {
    this.logService.consoleLog('2', "PC PedirAccesoEmp userYaCargado: " + this.dataUserService.userYaCargado);
    this.logService.consoleLog('2', "PC PedirAccesoEmp user: " + this.dataUserService.user.nombre);
    this.logService.consoleLog('2', "PC PedirAccesoEmp empresa: " + this.dataEmpresaService.empAut.nombre);
    if (this.dataUserService.userYaCargado) {
      this.logService.consoleLog('2', 'PC PedirAccesoEmp Usuario ya cargado: ' + this.dataUserService.user.email);
    }
  }

  ngOnInit() {
    this.sitio = this.dataEmpresaService.sitioElegido;
    if (this.sitio == 'EasyMed') {
      this.srcLogo = "assets/images/EMlogo2.svg";
    } else if (this.sitio == 'Efisys') {
      this.srcLogo = "assets/images/logo-efisys2.svg";
    }

    this.ocultaTopBar();
    this.ocultaFooter();

    //Para estar en este form debe haber hecho login y debe haber this.dataUserService.userAut
    //si no hay, es que no ha hecho login y por tanto debe salir y hacer login
    if (this.dataUserService.userAut.email != undefined && this.dataUserService.userAut.email != '') {
      this.logService.consoleLog('2', 'CC II UsrAut ya cargado');
      this.userAutActual = this.dataUserService.userAut;
      this.logService.consoleLog('2', "CC II userAutActual: " + this.userAutActual.email)
    } else {
      this.fireUserService.afLogout()
        .then(() => {
          this.logService.consoleLog('4', 'CC II UsrAut no cargado, logout ok');
          //alert('Servicio de usuarios de Efisys: salida exitosa');
          this.dataUserService.userAutUpdate(userAutVacio);
          this.dataUserService.userUpdate(userVacio);
          this.dataUserService.userYaCargadoUpdate(false);
          this.router.navigate(['/sitio-publico']);
        })
        .catch(err => {
          this.logService.consoleLog('9', 'CC II UsrAut no cargado, logout error');
          this.logService.consoleLog('9', 'CC II Problema en la salida: ' + err.code);
          this.logService.consoleLog('9', "CC II " + err.message);
          this.router.navigate(['/sitio-publico']);
        });
    }

  }

  ngOnDestroy(): void {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.muestraTopBar();
    this.muestraFooter();
    this.modeloRegistro = new PedirAccesoEmp;
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public findInvalidControls(f: FormGroup): string[] {
    return this.funcionesService.findInvalidControls(f);
  }

  public chkValido(f: FormGroup, nombre: string): boolean {
    return this.funcionesService.chkValido(f, nombre);
  }

  public asignaEstiloBody(): object {
    let estBody: object = {};
    if (this.sitio == 'EasyMed') {
      estBody = { "background-image": "url('/assets/images/36918105_xl_1280x853.png')" };
    } else if (this.sitio == 'Efisys') {
      estBody = { "background-image": "url('/assets/images/tienda.png')" };
    }
    return estBody;
  }

  asignaEstiloLogo(): object {
    let estLogo: object = {};
    if (this.sitio == 'EasyMed') {
      estLogo = {};
    } else if (this.sitio == 'Efisys') {
      estLogo = { "height": "67px" };
    }
    return estLogo;
  }

  public asignaEstilo(f: FormGroup, nombre: string): object {
    return this.funcionesService.asignaEstilo(f, nombre);
  }

  public asignaEstiloSubmitDisabled(f: FormGroup): object {
    return this.funcionesService.asignaEstiloSubmitDisabled(f);
  }


  clickChkAcepto(event) {
    if (event.target.checked) {
      this.okAcepto = true;
    } else {
      this.okAcepto = false;
    }
  }

  ocultaTopBar() {
    this.logService.consoleLog('2', "PC PedirAccesoEmp ocultaTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar w-nav/)
    ) {
      document.getElementById("navbar-1").className = "navbar-oculta";
    }
  }

  ocultaFooter() {
    this.logService.consoleLog('2', "PC PedirAccesoEmp ocultaFooter");
    //document.getElementById("boton").classList.toggle("active");
    if (
      document.getElementById("footer-1").className.match(/diag-wrapper/)
    ) {
      document.getElementById("footer-1").className = "footer-oculto";
    }
  }

  muestraTopBar() {
    this.logService.consoleLog('2', "PC PedirAccesoEmp muestraTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar-oculta/)
    ) {
      document.getElementById("navbar-1").className = "navbar w-nav";
    }
  }

  muestraFooter() {
    this.logService.consoleLog('2', "PC PedirAccesoEmp muestraFooter");
    if (
      document.getElementById("footer-1").className.match(/footer-oculto/)
    ) {
      document.getElementById("footer-1").className = "diag-wrapper";
    }
  }

  pedirAccesoEmpSubmit() {
    //esto evita que se envíe el mismo form varias veces
    this.logService.consoleLog('2', 'PC PedirAccesoEmp ' + JSON.stringify(this.formPedirAccesoEmp.value));
    this.modeloRegistro.autorizado = '-';
    this.modeloRegistro.nombre = this.formPedirAccesoEmp.value.fTxtNombre;
    this.modeloRegistro.ruc = this.formPedirAccesoEmp.value.fTxtRUC;
    this.modeloRegistro.fechaHora = this.fechaHoraService.formatFecha(new Date()) + "-" + this.fechaHoraService.formatHora(new Date());
    this.modeloRegistro.paeid = this.fechaHoraService.obtieneRandomFechaHora();
    this.modeloRegistro.tipoUsuarioSolicitado = 'Usuario';
    this.modeloRegistro.userAutSolicNombre = this.userAutActual.nombre;
    this.modeloRegistro.userAutSolicMail = this.userAutActual.email;
    this.modeloRegistro.uid = this.userAutActual.uid;
    this.modeloRegistro.nombreReal = 'Por confirmar';

    this.modeloEmpNue = JSON.parse(JSON.stringify(this.formPedirAccesoEmp.value));
    if (this.funcionesService.deepEqual(this.modeloEmpNue, this.modeloEmpAnt)) {
      this.logService.consoleLog('2', "PC PedirAccesoEmp Ya se envió esta solicitud");
      this.formDuplic = true;
      setTimeout(() => {
        this.formDuplic = false;
      }, 5000);
    } else {
      this.muestraService.muestraLoading(true);
      this.logService.consoleLog('2', "PC PedirAccesoEmp Primer envío");
      this.logService.consoleLog('2', 'PC PedirAccesoEmp Emp: ' + this.modeloRegistro.nombre);
      this.modeloEmpAnt = this.modeloEmpNue;
      //if (!this.dataUserService.userYaCargado) {
      //no hago este if porque userYaCargado aún no se ha grabado y aquí es seguro que vino acá luego del login
      //this.logService.consoleLog('4', 'PC PedirAccesoEmp registro, user no cargado');
      //} else {
      this.logService.consoleLog('2', 'PC PedirAccesoEmp registro, primera carga: ' + this.modeloRegistro.nombre);

      //creo  empresa en empAut/easymed con autorizado='N'
      this.empresaPedir = this.modeloRegistro;
      this.fireEmpresaService.createFirePedirAccesoEmp$(this.empresaPedir)
        .then(() => {
          this.logService.consoleLog('2', 'PC PedirAccesoEmp Crear PedirEmp ok')
          this.mensajeRegistro = 'Ha solicitado el acceso, pero todavía no está asignado.';
          this.mensajeRegistro2 = 'En un plazo de un día laborable el acceso será autorizado.';

          this.muestraService.muestraLoading(false);
          this.muestraService.muestraMsgbox('NE-001: Empresa creada', this.mensajeRegistro, this.mensajeRegistro2, 'Aceptar', 'ThumbsUp')
            .pipe(take(1))
            .subscribe(r => {
              this.logService.consoleLog('2', 'PC PedirAccesoEmp Respuesta: ' + r);
              this.fireUserService.afLogout();
              this.router.navigate(['/sitio-publico']);
            });
        })
        .catch(err => {
          this.muestraService.muestraLoading(false);
          this.logService.consoleLog('9', 'PC PedirAccesoEmp Error al crear empresa');
          this.logService.consoleLog('9', 'PC PedirAccesoEmp ' + err.code);
          this.logService.consoleLog('9', 'PC PedirAccesoEmp ' + err.message);
        })

      //}
    }
  }
}
